<template>
  <v-card>
    <v-card-title>
       <span> Vehiculos</span>
     
       <v-btn dark color="indigo" class="mx-5" @click="ActualizarGrid()"><v-icon>autorenew</v-icon></v-btn>

      <v-text-field class="mx-5"
        v-model="search"
        append-icon="mdi-magnify"
        label="Buscar"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="Arrayflota"
      :search="search"
    >


    <template v-slot:[`item.nombre`]="{ item }">
      <span>{{item.nombre}}</span>
     </template>
    
    
    <template v-slot:[`item.icono`]="{ item }">
        <img  :src="item.icono" v-bind:alt="item.icono"   style="width: 25px; height: 30px"/>
     </template>


      <template v-slot:[`item.total_odometro`]="{ item }">
        
        <v-chip class="ma-2" color="green" text-color="white">{{item.total_odometro}}</v-chip>
       
        <!--v-btn v-show="item.observacion!=''" @click="VerDetalle(item)">{{item.observacion}}</v-btn-->

     </template>

     <template v-slot:[`item.consumo_km_x_gl`]="{ item }">
      <span>{{item.consumo_km_x_gl}}</span>
      <v-icon color="info" @click="CambiarConsumo(item)">settings</v-icon>
     </template>


     <template v-slot:[`item.actual_combustible`]="{ item }">
      <span>{{item.actual_combustible}}</span>
      <v-icon color="red">gas_meter</v-icon>
     </template>


     


     

                                                             
</v-data-table>


<v-dialog v-model="dialog" width="370px">
   <v-card>

     <v-toolbar dark color="indigo">
       <v-toolbar-title>Observacion :{{detalle.unidad}}</v-toolbar-title>
       <v-spacer></v-spacer>
       <v-icon dark @click="dialog=false">close</v-icon>
     </v-toolbar>

        <v-card-text style="height:150px;" class="text--center">
       
      
         <span class="mt-5">Observacion: {{detalle.observacion}}</span>
    
        </v-card-text>

        <v-card-actions>
         <v-btn color="red" dark @click="EliminarObservacion()" class="mx-2">Eliminar</v-btn>
          <v-btn outlined color="indigo" @click="dialog=false">cancelar</v-btn>

</v-card-actions>

   </v-card>
</v-dialog>


<v-dialog v-model="dialogCombustible" width="600px">
   <v-card>

     <v-toolbar dark color="indigo">
       <v-toolbar-title>Rendimiento KM x Gl:{{detalle.unidad}}</v-toolbar-title>
       <v-spacer></v-spacer>
       <v-icon dark @click="dialogCombustible=false">close</v-icon>
     </v-toolbar>

        <v-card-text style="height:150px;" class="text--center">
       
        <v-row class="mt-5">


          <v-col  cols="12" sm="12" md="12">
                    <v-text-field v-model="detalle.consumo_km_x_gl" prepend-icon="local_gas_station" label="KM x Galon"></v-text-field>
            </v-col>

      
        </v-row>
    
        </v-card-text>

        <v-card-actions>
         <v-btn color="success" dark @click="EstablecerConsumo()" class="mx-2">Guardar</v-btn>
          <v-btn outlined color="indigo" @click="dialogCombustible=false">cancelar</v-btn>

</v-card-actions>

   </v-card>
</v-dialog>

  <!--p class="subtitle-2 ml-2">
        Sensor tomado de Loc Aid :type: "odometer" , name: "Odometro"
    </p--->


  </v-card>
</template>

<script>

import axios from 'axios';
import { mapMutations, mapState } from "vuex";

  export default {
    data () {
      return {
        Arrayflota:[],
        search: '',
        headers: [
          { text: 'Icono', value: 'icono' },
          { text: 'Imei', value: 'id_avl' },
          { text: 'nombre', value: 'nombre' },
          { text: 'placa', value: 'placa' },
          { text: 'Flota', value: 'flota' },
          { text: 'total Distancia', value: 'total_distance' },
          { text: 'total_odometro', value: 'total_odometro' },

          { text: 'consumo km x Gl', value: 'consumo_km_x_gl' },
          { text: 'actual_combustible', value: 'actual_combustible' },
          { text: 'Actualizacion', value: 'ultimaTx'},

        ],
        dialog:false,
        detalle:{},

        dialogCombustible:false,
      }
    },
    created () {
      this.listar();
     
    },
    methods:{

       ...mapMutations(['mostrarLoading','ocultarLoading']),

         listar(){

                 this.Arrayflota=[];

                 this.mostrarLoading({titulo:'Accediendo a datos'});
                 let config={headers:{token:this.token}};
                let me=this;
                axios.get(`vehiculos/${this.usuario.id_usr_empresa._id}`,
                    config
                    ).then(function(response){
                        console.log(response);
                        me.Arrayflota=response.data;

                        me.Arrayflota.map(function(x){
                          x.total_odometro=parseFloat(x.total_distance)+ parseFloat(x.ajuste_odom_fisico);
                        });


                        



                        me.ocultarLoading();
                    }).catch(function(error){ console.log(error); });

          },
 

          ActualizarGrid(){

             let config={headers:{ token:this.token}};
            let me=this;
              me.mostrarLoading({titulo:'actualizando con loc aid'});
            axios.post('ActualizarLocAid',{ '_id':this.usuario.id_usr_empresa._id,
                           
                          },
                        config
                      ).then(response=>{
                      
                          console.log(response);
                          me.ocultarLoading();
                          me.listar();

                      }).catch(e=>{ console.log(e) });            
         }, 
      
         CambiarImgUrl(picture){
            picture=picture.substring(0,picture.length - 5);
            if(picture.slice(-1)!='/'){
                    picture=picture.substring(0,picture.length - 1);
                }
                return (picture+'/E.png');
         },

         VerDetalle(item){

           if(item.observacion!=''){
              this.detalle={
                '_id':item._id,
                'unidad':item.nombre+' / '+item.placa, 
                'observacion':item.observacion
                };

                this.dialog=true;
           }
          

         },


         EliminarObservacion(){

              let config={headers:{token:this.token}};

               this.mostrarLoading({titulo:'Accediendo a datos'});

               let id=this.detalle._id;

                    axios.put(`vehiculo/${id}`,
                      {'observacion':''},
                      config
                        ).then(response=>{
                      
                         console.log(response);
                        
                         this.dialog=false;
                         this.listar();
                         this.ocultarLoading();

                  }).catch(e=>{
                        console.log(e)
                  });


         },

         CambiarConsumo(item){


          //console.log(item);
         

            this.detalle={
                '_id':item._id,
                'unidad':item.nombre+' / '+item.placa, 
                'consumo_km_x_gl':item.consumo_km_x_gl
                };

            this.dialogCombustible=true;
         },

         EstablecerConsumo(){

           let config={headers:{token:this.token}};

               this.mostrarLoading({titulo:'Accediendo a datos'});

               let id=this.detalle._id;

                    axios.put(`vehiculo/${id}`,
                      {'consumo_km_x_gl':this.detalle.consumo_km_x_gl},
                      config
                        ).then(response=>{
                      
                         console.log(response);
                        
                         this.dialogCombustible=false;
                         this.listar();
                         this.ocultarLoading();

                  }).catch(e=>{
                        console.log(e)
                  });

         }

    }, computed:{

       ...mapState(['usuario', 'token']),


    }
  }
</script>